import { IMetrics, PickPublic } from '../lib/utils.ts'
import { HttpClient } from './httpClient.ts'

export type ProgressApi = PickPublic<AppProgressApi>
export class AppProgressApi {
  constructor(private httpClient: HttpClient) {}

  async getMetrics(courseId?: number) {
    const params = new URLSearchParams()
    if (courseId !== undefined) params.set('course_id', String(courseId))
    const query = params.toString()
    const suffix = query ? `?${query}` : ''
    return await this.httpClient.get<IMetrics[]>(
      `/api/account/stat/metrics/${suffix}`,
    )
  }

  async getCurrentLessonMetrics(lessonId: string, courseId?: number) {
    const params = new URLSearchParams()
    if (courseId !== undefined) params.set('course_id', String(courseId))
    const query = params.toString()
    const suffix = query ? `?${query}` : ''
    return await this.httpClient.get<IMetrics[]>(
      `/api/account/stat/metrics/lesson/${lessonId}/${suffix}`,
    )
  }
}
